export default {
  default: {
    imported: '(Imported)',
  },
}
